export const POLL_INTERVAL = 6000
export const POLL_INTERVAL_MAX = 30000
export const POLL_TIMEOUT = 420000
export const BACK_OFF_RATE = 0.25
